module.exports = {
	"articleTitle1": "The Michigan Daily's guide to Restaurant Week ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "bd's Mongolian Grill",
	"articleLink1": "https://www.michigandaily.com/section/arts/restaurant-week-guide",
	"articleLink2": "https://www.michigandaily.com/arts/1food-column24",
	"articleSnippet1": "Jan 12, 2016 ... Okay, so you can probably get rid of some of them — there's never a reason to go \nto bd's Mongolian Grill; I have never walked by Ama Bistro ...",
	"articleSnippet2": "Jan 24, 2013 ... BUST: bd's Mongolian Grill. Not that I have anything against being overcharged \nto stand in line and have my bowl of stir-fry pulverized by ...",
	"foodRecommendations": [
		{
			"text": "DIY stirfry",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "Nathan Wood: Serving up the 'musts and busts' of restaurant week",
	"address": "200 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2803,
		"lng": -83.7489
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/bdsmongoliangrill.json
// module id = 824
// module chunks = 0